export default class GetReferenciaById {
  #repository

  constructor(repository) {
    this.#repository = repository
  }

  async execute(idPersonal) {
    try {
      const result = await this.#repository.getById(idPersonal)
      return result
    } catch (error) {
      console.log(error)
      throw error
    }
  }
}
